import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	fullDialog: {
		height: "100%"
	},
	dialogContent: {
		height: "100%",
		overflow: "hidden",
		"&:first-child": {
			paddingTop: 0
		}
	},
	dialogTitle: {
		color: colors.gray[700],
		fontWeight: "bold",
		fontSize: 24,
		lineHeight: 1.5
	},
	dialogDescription: {
		maxWidth: 550,
		color: colors.gray[700]
	},
	planAddonsInformationText: {
		fontSize: 16,
		fontWeight: 700,
		maxWidth: 440,
		color: colors.purple[500]
	},
	termsOfUse: {
		fontStyle: "italic",
		color: colors.gray[700]
	},
	termsOfUseLink: {
		color: colors.gray[700],
		fontWeight: "bold",
		"&:hover": {
			color: colors.purple[700]
		}
	},
	dialogActionPrimaryButton: {
		width: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[500]),
		color: colors.gray[0],
		textTransform: "uppercase",
		boxShadow: "none",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[600])
		}
	},
	dialogActionSecondaryButton: {
		color: colors.gray[500],
		fontWeight: "normal",
		"&:hover": {
			background: "transparent",
			color: colors.gray[600]
		}
	},
	benefitListItem: {
		display: "flex",
		alignItems: "start",
		paddingLeft: 0
	},
	benefitsList: {
		listStyleType: "none",
		display: "flex",
		flexDirection: "column",
		gap: 12
	},
	benefitItem: {
		display: "flex",
		alignItems: "start",
		gap: 8
	},
	benefitItemIcon: {
		color: colors.purple[500]
	},
	benefitItemIconAvatar: {
		width: 22,
		height: 22,
		backgroundColor: colors.purple[500]
	},
	benefitItemIconInAvatar: {
		width: 14,
		height: 14,
		color: colors.gray[0]
	},
	radioOptionsCard: {
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: 16,
		padding: theme.spacing(1, 2),
		maxWidth: 440
	},
	radioOptionMinutes: {
		fontWeight: "bold",
		color: colors.gray[700]
	},
	radioOptionMinutesSelected: {
		color: colors.purple[500]
	},
	radioOptionArrow: {
		color: colors.gray[500]
	},
	radioOptionArrowSelected: {
		color: colors.purple[500]
	},
	radioOptionPrice: {
		color: colors.gray[700]
	},
	radioOptionPriceSelected: {
		color: colors.purple[500]
	},
	radioOptionPricePerMinute: {
		fontWeight: "bold",
		color: colors.gray[500],
		fontSize: 14
	},
	radioOptionPricePerMinuteSelected: {
		color: colors.purple[500]
	},
	imageContainer: {
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		width: "100%",
		height: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.green[100]),
		[theme.breakpoints.down("sm")]: {
			display: "none"
		},
		overflow: "hidden"
	},
	upsellImage: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		objectFit: "cover"
	},
	closeButton: {
		padding: 4,
		position: "absolute",
		...ColorUtil.getBackgroundAndContrastColor(colors.green[200]),
		borderRadius: "100%",
		top: 12,
		right: 12,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[300])
		}
	}
}))

export default useStyles
